import { StackActions } from '@dmi/mobile/node_modules/@react-navigation/native';

export default StackActions;
